import React, { createContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_URL } from "./config";

export const UserRoleContext = createContext();

const UserRoleProvider = ({ children }) => {
    const [role, setRole] = useState(null); // Stores the user role
    const [loading, setLoading] = useState(true); // Tracks loading state
    // Fetch user role from the backend
    const fetchUserRole = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_URL}fetch-user-role.php`, { withCredentials: true });
            setRole(Number(response.data.role) || null); // Example: "admin", "user", "super"
            // getRoleName();
        } catch (error) {
            console.error("Error fetching user role:", error);
            setRole(null); // Reset role on error
        } finally {
            setLoading(false);
        }
    }, []);

    // Fetch role when the context initializes
    useEffect(() => {
        fetchUserRole();
    }, [fetchUserRole]);

    // const getRoleName = () => {
    //     if (role === 1) {
    //         setRoleName('super')
    //     } else if (role === 2) {
    //         setRoleName('owner')
    //     } else if (role === 3) {
    //         setRoleName('admin')
    //     } else {
    //         setRoleName('normal')
    //     }
    // }

    return (
        <UserRoleContext.Provider value={{ role, loading, refreshRole: fetchUserRole }}>
            {children}
        </UserRoleContext.Provider>
    );
};

export default UserRoleProvider;
